import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { SessionTimerService } from './session-timer.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const sessionTimer = inject(SessionTimerService);

  const isAuthEndpoint = req.url.includes('/api/auth/login') || req.url.includes('/api/auth/logout');
  const withCredentials = req.clone({ withCredentials: true });

  if (!isAuthEndpoint && auth.isLoggedIn()) {
    sessionTimer.recordActivity();
  }

  return next(withCredentials).pipe(
    catchError((error) => {
      const status = error instanceof HttpErrorResponse ? error.status : error?.status;
      const backendStatus = error instanceof HttpErrorResponse
        ? (error.error?.status ?? error.error?.statusCode)
        : undefined;
      const effectiveStatus = status || backendStatus;
      const isAuthFailure = effectiveStatus === 401 || effectiveStatus === 403;
      const isApiNetworkFailure = status === 0 && error instanceof HttpErrorResponse && error.url?.includes('/api/');
      if ((isAuthFailure || isApiNetworkFailure) && !isAuthEndpoint) {
        auth.logout();
        router.navigateByUrl('/login');
      }
      return throwError(() => error);
    })
  );
};
